// extracted by mini-css-extract-plugin
export default {"block":"Skeleton_block__6YX1R","secondaryColor":"Skeleton_secondaryColor__bjl02"};